import { createMachine, assign } from 'xstate';

export const STATES = {
  noSearch: '@states/noSearch', // nothing entered into the search input
  blankSearch: '@states/blankSearch', // spaces entered into search input
  hasResults: '@states/hasResults', // valid search query with results
  noResults: '@states/noResults' // valid search query with no results
};

export const EVENTS = {
  searchTermUpdated: '@events/searchTermUpdated'
};

const searchReviews = (reviews = [], term = '') => {
  if (!term) {
    return reviews;
  }

  return reviews.filter((review) => {
    const sanitizedTerm = term.trim().toLowerCase();

    // Skip reviews with null or undefined body
    if (!review.body) {
      return false;
    }

    const sanitizedReviewBody = review.body.trim().toLowerCase();

    return sanitizedReviewBody.includes(sanitizedTerm);
  });
};

const guards = {
  emptySearchTerm: ({ event }) => event.data.length === 0,
  blankSearchTerm: ({ event }) => event.data.trim().length === 0,
  hasResults: ({ context, event }) =>
    searchReviews(context.reviews, event.data).length > 0
};

const actions = {
  updateTerm: assign({
    searchTerm: ({ event }) => event.data
  }),
  searchReviews: assign({
    displayReviews: ({ context }) =>
      searchReviews(context.reviews, context.searchTerm)
  }),
  resetSearch: assign({
    displayReviews: ({ context }) => context.reviews
  })
};

const createSearchReviewsMachine = ({ reviews }) =>
  createMachine(
    {
      id: 'search-reviews-machine',
      initial: STATES.noSearch,
      context: {
        reviews,
        searchTerm: '',
        displayReviews: reviews
      },
      on: {
        // v5 requires the leading "." for root-level child targets
        [EVENTS.searchTermUpdated]: [
          {
            guard: 'emptySearchTerm',
            actions: ['updateTerm', 'resetSearch'],
            target: `.${STATES.noSearch}`
          },
          {
            guard: 'blankSearchTerm',
            actions: 'updateTerm',
            target: `.${STATES.blankSearch}`
          },
          {
            guard: 'hasResults',
            actions: ['updateTerm', 'searchReviews'],
            target: `.${STATES.hasResults}`
          },
          {
            actions: ['updateTerm'],
            target: `.${STATES.noResults}`
          }
        ]
      },
      states: {
        [STATES.noSearch]: {},
        [STATES.blankSearch]: {},
        [STATES.hasResults]: {},
        [STATES.noResults]: {}
      }
    },
    {
      guards,
      actions
    }
  );

export default createSearchReviewsMachine;
